export default "__VITE_ASSET__ErUnYFGU__"